import {
	MAP_VIEWBOX,
	roads,
	ditchXPositions,
	gates,
	getDitchPath,
} from '#app/utils/farm-map.ts'

export function FarmMap({ children }: { children?: React.ReactNode }) {
	const { top, bottom, left, citrus } = roads

	return (
		<svg
			viewBox={`0 0 ${MAP_VIEWBOX.width} ${MAP_VIEWBOX.height}`}
			className="h-auto w-full"
			role="img"
			aria-label="Map of ditches 1 through 9, Gate 10-01, and Gate 10-03"
		>
			{/* boundary roads */}
			<line
				x1={left}
				y1={top}
				x2={citrus}
				y2={top}
				stroke="black"
				strokeWidth={8}
			/>
			<line
				x1={left}
				y1={top}
				x2={citrus}
				y2={top}
				stroke="#9aa3ad"
				strokeWidth={6}
			/>
			<line
				x1={left}
				y1={bottom}
				x2={citrus}
				y2={bottom}
				stroke="black"
				strokeWidth={8}
			/>
			<line
				x1={left}
				y1={bottom}
				x2={citrus}
				y2={bottom}
				stroke="#9aa3ad"
				strokeWidth={6}
			/>
			<text
				x={(left + citrus) / 2}
				y={top - 46}
				textAnchor="middle"
				className="fill-muted-foreground text-[22px] font-semibold"
			>
				Northern Ave
			</text>
			<text
				x={(left + citrus) / 2}
				y={bottom + 54}
				textAnchor="middle"
				className="fill-muted-foreground text-[22px] font-semibold"
			>
				Glendale Ave
			</text>

			{/* ditches 1-8, straight south (Ditch 1 is the westmost line) */}
			{Object.entries(ditchXPositions).map(([ditch, x]) => (
				<g key={ditch}>
					{Number(ditch) % 2 === 1 ? (
						<path
							d={getDitchPath(Number(ditch))}
							fill="none"
							stroke="black"
							strokeWidth={7}
						/>
					) : null}
					<path
						d={getDitchPath(Number(ditch))}
						fill="none"
						stroke="#9ab5c2"
						strokeWidth={5}
					/>
					<text
						x={x}
						y={bottom + 24}
						textAnchor="middle"
						className="fill-foreground text-[20px] font-bold"
					>
						D-{ditch}
					</text>
					{({ 3: '185rd', 5: '183rd', 7: '181st' } as Record<number, string>)[
						Number(ditch)
					] ? (
						<text
							x={x - 32}
							y={bottom - 12}
							textAnchor="middle"
							className="fill-muted-foreground text-[14px] font-semibold"
						>
							{
								(
									{ 3: '185rd', 5: '183rd', 7: '181st' } as Record<
										number,
										string
									>
								)[Number(ditch)]
							}
						</text>
					) : null}
				</g>
			))}

			{/* ditch 9: east along Northern Ave, from Gate 10-01 to the Citrus corner */}
			<path d={getDitchPath(9)} fill="none" stroke="#9ab5c2" strokeWidth={5} />
			<text
				x={(gates['10-03']!.x + citrus) / 2}
				y={top - 28}
				textAnchor="middle"
				className="fill-foreground text-[20px] font-bold"
			>
				D-9
			</text>

			{/* Citrus: the east boundary street, not a ditch */}
			<line
				x1={citrus}
				y1={top}
				x2={citrus}
				y2={bottom}
				stroke="black"
				strokeWidth={8}
			/>
			<line
				x1={citrus}
				y1={top}
				x2={citrus}
				y2={bottom}
				stroke="#9aa3ad"
				strokeWidth={6}
			/>
			<text
				x={citrus + 24}
				y={(top + bottom) / 2}
				textAnchor="middle"
				transform={`rotate(90 ${citrus + 24} ${(top + bottom) / 2})`}
				className="fill-muted-foreground text-[20px] font-semibold"
			>
				Citrus
			</text>
			<text
				x={left - 24}
				y={(top + bottom) / 2}
				textAnchor="middle"
				transform={`rotate(-90 ${left - 24} ${(top + bottom) / 2})`}
				className="fill-muted-foreground text-[20px] font-semibold"
			>
				Perryville
			</text>

			{/* gates */}
			{Object.entries(gates).map(([entry, gate]) => (
				<g key={entry}>
					<rect
						x={gate.x - 14}
						y={gate.y - 14}
						width={28}
						height={28}
						className="fill-red-700 stroke-red-950"
						strokeWidth={2}
					/>
					<text
						x={gate.x}
						y={gate.y - 20}
						textAnchor="middle"
						className="fill-red-700 text-[20px] font-bold"
					>
						Gate {gate.label}
					</text>
				</g>
			))}

			{children}
		</svg>
	)
}
